module.exports = __webpack_public_path__ + "static/img/1.e7989bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/1.jpg
// module id = ne6x
// module chunks = 21